// Shared currency formatter. Defaults to COP (the platform-wide default for organizations).
export const SUPPORTED_CURRENCIES = [
  { code: 'COP', label: 'Peso colombiano (COP)' },
  { code: 'USD', label: 'Dólar estadounidense (USD)' },
  { code: 'MXN', label: 'Peso mexicano (MXN)' },
  { code: 'EUR', label: 'Euro (EUR)' },
  { code: 'PEN', label: 'Sol peruano (PEN)' },
  { code: 'CLP', label: 'Peso chileno (CLP)' },
  { code: 'ARS', label: 'Peso argentino (ARS)' },
  { code: 'BRL', label: 'Real brasileño (BRL)' },
  { code: 'GBP', label: 'Libra esterlina (GBP)' },
] as const;

export type SupportedCurrency = (typeof SUPPORTED_CURRENCIES)[number]['code'];

export function formatCurrency(value: number, currency: string = 'COP'): string {
  const safe = currency && currency.length === 3 ? currency : 'COP';
  try {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: safe,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  } catch {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  }
}
